module.exports = __webpack_public_path__ + "img/folder-create.57e37d01.svg";